import { render, staticRenderFns } from "./Users_oncall_duties.vue?vue&type=template&id=c68a113c&scoped=true&lang=pug&"
import script from "./Users_oncall_duties.vue?vue&type=script&lang=coffee&"
export * from "./Users_oncall_duties.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68a113c",
  null
  
)

export default component.exports